export enum FileAceClaimSteps {
  SELECT_PLAN = "Select your Plan",
  ADD_CLAIM_ITEMS = "Select damaged items under your plan",
  ADD_CLAIM_ITEMS_DETAILS = "Confirm/Update Item Details", //'Confirm item details',
  ADD_CLAIM_ITEMS_DAMAGE_DETAILS = "Report your damage",
  REVIEW_CLAIM_DETAILS = "Review claim details",
}

export const aceClaimStepsData = [
  {
    step_num: 1,
    title: FileAceClaimSteps.SELECT_PLAN,
  },
  {
    step_num: 2,
    title: FileAceClaimSteps.ADD_CLAIM_ITEMS,
  },
  {
    step_num: 3,
    title: FileAceClaimSteps.ADD_CLAIM_ITEMS_DETAILS,
  },
  {
    step_num: 4,
    title: FileAceClaimSteps.ADD_CLAIM_ITEMS_DAMAGE_DETAILS,
  },
  {
    step_num: 5,
    title: FileAceClaimSteps.REVIEW_CLAIM_DETAILS,
  },
];
